import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'ecole_cookie_consent';
export const COOKIE_CONSENT_EVENT = 'ecole_cookie_consent_change';

export type CookieConsent = 'accepted' | 'rejected';

export function getCookieConsent(): CookieConsent | null {
  return localStorage.getItem(STORAGE_KEY) as CookieConsent | null;
}

export function CookieConsentBanner() {
  const { t } = useTranslation();
  const [consent, setConsent] = useState<CookieConsent | null>(null);

  useEffect(() => {
    setConsent(getCookieConsent());
  }, []);

  function choose(value: CookieConsent) {
    localStorage.setItem(STORAGE_KEY, value);
    setConsent(value);
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT));
  }

  if (consent) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-manuscript-line-strong bg-manuscript-card font-manuscript shadow-lg">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 py-5 sm:flex-row sm:justify-between">
        <p className="text-sm text-manuscript-ink-soft">
          {t('cookieConsent.message')}{' '}
          <Link to="/confidentialite" className="underline hover:text-manuscript-ink">
            {t('cookieConsent.learnMore')}
          </Link>
        </p>
        <div className="flex shrink-0 items-center gap-3">
          <button
            type="button"
            onClick={() => choose('rejected')}
            className="rounded-sm border border-manuscript-ink px-4 py-2 text-sm font-semibold text-manuscript-ink transition-colors hover:bg-paper-200"
          >
            {t('cookieConsent.reject')}
          </button>
          <button
            type="button"
            onClick={() => choose('accepted')}
            className="rounded-sm bg-manuscript-ink px-4 py-2 text-sm font-semibold text-paper-50 transition-colors hover:bg-manuscript-ink-soft"
          >
            {t('cookieConsent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
